module.exports = __webpack_public_path__ + "static/media/forward-button.3b1b46d5.svg";